export const useLanguageWarningModalContent = () => ({
  title: 'page.language-warning-modal-title',
  description: 'page.language-warning-modal-desc',
  buttonText: 'page.language-warning-modal-button',
})
